import BodyView from "@/layout/BodyView.vue";
import ShippingCourier from "@/pages/shipping/courier/Index.vue";
import ShippingPicking from "@/pages/shipping/picking-list/Index.vue";

export const route = 
{
  path: "/shipping",
  component: BodyView,
  children: [
    {
      path: "courier",
      name: "courier",
      component: ShippingCourier,
      meta: {
        title: 'Courier | INDOFORCETECH',
      }
    },
    {
      path: "picking",
      name: "picking",
      component: ShippingPicking,
      meta: {
        title: 'Picking | INDOFORCETECH',
      }
    }
  ]
}